module.exports = __webpack_public_path__ + "static/file-image-b5d888dcd6bc97e31b9f41302ca21e56.jpg";